import { render, staticRenderFns } from "./shipping_result.vue?vue&type=template&id=d9a73066&scoped=true&"
import script from "./shipping_result.vue?vue&type=script&lang=js&"
export * from "./shipping_result.vue?vue&type=script&lang=js&"
import style0 from "./shipping_result.vue?vue&type=style&index=0&id=d9a73066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a73066",
  null
  
)

export default component.exports